export const weekType = {
  'seg': 'segunda-feira',
  'ter': 'terça-feira',
  'qua': 'quarta-feira',
  'qui': 'quinta-feira',
  'sex': 'sexta-feira',
}